import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_6eafd842 from 'nuxt_plugin_plugin_6eafd842' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_460622ec from 'nuxt_plugin_plugin_460622ec' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_linkedin_1c53c042 from 'nuxt_plugin_linkedin_1c53c042' // Source: ./linkedin.js (mode: 'client')
import nuxt_plugin_image_a48c595a from 'nuxt_plugin_image_a48c595a' // Source: ./image.js (mode: 'all')
import nuxt_plugin_gtm_35a5532e from 'nuxt_plugin_gtm_35a5532e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtsocketio_62eeb40a from 'nuxt_plugin_nuxtsocketio_62eeb40a' // Source: ./nuxt-socket-io.js (mode: 'all')
import nuxt_plugin_pluginutils_708012e3 from 'nuxt_plugin_pluginutils_708012e3' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_06c7736e from 'nuxt_plugin_pluginrouting_06c7736e' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_b144427e from 'nuxt_plugin_pluginmain_b144427e' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_7a9a5350 from 'nuxt_plugin_axios_7a9a5350' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtsegment_7aa9db12 from 'nuxt_plugin_nuxtsegment_7aa9db12' // Source: ./nuxt-segment.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_4da4c600 from 'nuxt_plugin_cookieuniversalnuxt_4da4c600' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_c18f99be from 'nuxt_plugin_nuxtuseragent_c18f99be' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_recaptcha_8d070e72 from 'nuxt_plugin_recaptcha_8d070e72' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_distplugin2d60e9a7_dc8e4492 from 'nuxt_plugin_distplugin2d60e9a7_dc8e4492' // Source: ./dist.plugin.2d60e9a7.js (mode: 'client')
import nuxt_plugin_dayjsplugin_3774af85 from 'nuxt_plugin_dayjsplugin_3774af85' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_axtenpackages_298bce6d from 'nuxt_plugin_axtenpackages_298bce6d' // Source: ../plugins/axten-packages.js (mode: 'client')
import nuxt_plugin_docspackage_3036c88d from 'nuxt_plugin_docspackage_3036c88d' // Source: ../plugins/docs-package.js (mode: 'client')
import nuxt_plugin_dayjsformatters_7a85e886 from 'nuxt_plugin_dayjsformatters_7a85e886' // Source: ../plugins/dayjs-formatters.ts (mode: 'all')
import nuxt_plugin_axios_5659cf26 from 'nuxt_plugin_axios_5659cf26' // Source: ../plugins/axios.ts (mode: 'all')
import nuxt_plugin_directives_521c0486 from 'nuxt_plugin_directives_521c0486' // Source: ../plugins/directives.js (mode: 'client')
import nuxt_plugin_iframescrolllistener_9fac63e8 from 'nuxt_plugin_iframescrolllistener_9fac63e8' // Source: ../plugins/iframe-scroll-listener.ts (mode: 'client')
import nuxt_plugin_gtag_0a2caf78 from 'nuxt_plugin_gtag_0a2caf78' // Source: ../plugins/gtag.ts (mode: 'client')
import nuxt_plugin_vwo_2fdbbcd6 from 'nuxt_plugin_vwo_2fdbbcd6' // Source: ../plugins/vwo.ts (mode: 'client')
import nuxt_plugin_auth_43d0a7d8 from 'nuxt_plugin_auth_43d0a7d8' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s • Machinations.io","title":"Machinations","htmlAttrs":{"lang":"en"},"meta":[{"hid":"charset","charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"google-site-verification","content":"RaDW1tW_a49KIuTd99HmSr4QhsK-tuG3JcnjJKE1TdA"},{"hid":"description","name":"description","content":"The browser-based platform to Design, Prototype &amp; Handoff game systems."},{"hid":"format-detection","name":"format-detection","content":"telephone=no"},{"hid":"theme-color","name":"theme-color","content":"#fefefe"},{"hid":"robots","name":"robots","content":"index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"},{"hid":"og:locale","name":"og:locale","content":"en_US"},{"hid":"og:type","name":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"Machinations.io"},{"hid":"og:description","name":"og:description","property":"twitter:description","content":"The browser-based platform to Design, Prototype &amp; Handoff game systems."},{"hid":"og:url","name":"og:url","content":"https:\u002F\u002Fmachinations.io\u002F"},{"hid":"og:site_name","name":"og:site_name","property":"twitter:title","content":"Machinations.io"},{"hid":"og:image","name":"og:image","property":"og:image","content":"https:\u002F\u002Fmachinations.io\u002Fwp-content\u002Fuploads\u002F2025\u002F04\u002FMachinationsOGImage.png"},{"hid":"og:image:width","name":"og:image:width","content":"1200"},{"hid":"og:image:height","name":"og:image:height","content":"630"},{"hid":"og:image:type","name":"og:image:type","content":"image\u002Fpng"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"@machinationsio"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"src":"https:\u002F\u002Fsecure.24-information-acute.com\u002Fjs\u002F787182.js","ssr":false,"async":false,"defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6eafd842 === 'function') {
    await nuxt_plugin_plugin_6eafd842(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_460622ec === 'function') {
    await nuxt_plugin_plugin_460622ec(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_linkedin_1c53c042 === 'function') {
    await nuxt_plugin_linkedin_1c53c042(app.context, inject)
  }

  if (typeof nuxt_plugin_image_a48c595a === 'function') {
    await nuxt_plugin_image_a48c595a(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_35a5532e === 'function') {
    await nuxt_plugin_gtm_35a5532e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsocketio_62eeb40a === 'function') {
    await nuxt_plugin_nuxtsocketio_62eeb40a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_708012e3 === 'function') {
    await nuxt_plugin_pluginutils_708012e3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_06c7736e === 'function') {
    await nuxt_plugin_pluginrouting_06c7736e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_b144427e === 'function') {
    await nuxt_plugin_pluginmain_b144427e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7a9a5350 === 'function') {
    await nuxt_plugin_axios_7a9a5350(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtsegment_7aa9db12 === 'function') {
    await nuxt_plugin_nuxtsegment_7aa9db12(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_4da4c600 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_4da4c600(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_c18f99be === 'function') {
    await nuxt_plugin_nuxtuseragent_c18f99be(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_8d070e72 === 'function') {
    await nuxt_plugin_recaptcha_8d070e72(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_distplugin2d60e9a7_dc8e4492 === 'function') {
    await nuxt_plugin_distplugin2d60e9a7_dc8e4492(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_3774af85 === 'function') {
    await nuxt_plugin_dayjsplugin_3774af85(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axtenpackages_298bce6d === 'function') {
    await nuxt_plugin_axtenpackages_298bce6d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_docspackage_3036c88d === 'function') {
    await nuxt_plugin_docspackage_3036c88d(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsformatters_7a85e886 === 'function') {
    await nuxt_plugin_dayjsformatters_7a85e886(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659cf26 === 'function') {
    await nuxt_plugin_axios_5659cf26(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directives_521c0486 === 'function') {
    await nuxt_plugin_directives_521c0486(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_iframescrolllistener_9fac63e8 === 'function') {
    await nuxt_plugin_iframescrolllistener_9fac63e8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_0a2caf78 === 'function') {
    await nuxt_plugin_gtag_0a2caf78(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vwo_2fdbbcd6 === 'function') {
    await nuxt_plugin_vwo_2fdbbcd6(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_43d0a7d8 === 'function') {
    await nuxt_plugin_auth_43d0a7d8(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
